<div
  class="modal fade show d-block"
  tabindex="-1"
  *ngIf="isVisible"
  [@fadeSlide]
  [ngClass]="{
    'fullscreen-wrapper': position === 'fullscreen',
    'non-fullscreen-wrapper': position !== 'fullscreen',
    'left-or-right': position === 'left' || position === 'right'
  }"
>
  <div
    class="modal-dialog"
    [ngClass]="{
      'modal-fullscreen': position === 'fullscreen',
      'modal-center': position === 'centered',
      'modal-left': position === 'left',
      'modal-right': position === 'right'
    }"
  >
    <div class="modal-content d-flex flex-column p-0" [ngClass]="{ 'h-100': position === 'fullscreen' }">
      <div class="modal-header justify-content-center sticky-top bg-white border-bottom">
        <h5 class="modal-title text-center w-100 m-0">{{ title }}</h5>
        <button type="button" class="btn-close position-absolute end-0 me-3" (click)="onClose()"></button>
      </div>

      <div class="modal-body overflow-auto flex-grow-1 p-3">
        <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
      </div>
    </div>
  </div>
</div>
